import React, { useEffect, useState } from 'react';
import utils, { INTERVENTION_STATUS } from 'utils';

export const SessionCounter = (props) => {

    const [currentClock, setCurrentClock] = useState({ days: null, hours: null, minutes: null, seconds: null });
    const interventionIsClosed = props.task.status.statusId === INTERVENTION_STATUS.COMPLETED || props.task.status.statusId === INTERVENTION_STATUS.ARCHIVED || props.task.status.statusId === INTERVENTION_STATUS.ABORTED;

    const updateClock = (endTime, initTime) => {
        var diffTime = endTime - initTime;
        var values = utils.msToDHMS(diffTime).split(",");
        setCurrentClock({ days: values[0], hours: values[1], minutes: values[2], seconds: values[3] })
    }

    useEffect(() => {
        var taskDate = props.task.creationDate;
        if (!interventionIsClosed) {
            var interId = window.setInterval(() => {
                updateClock(new Date(), new Date(taskDate));
            }, 1);
            return () => clearInterval(interId);
        } else {
            updateClock(new Date(props.task.statusDate), new Date(taskDate));
        }
    }, [props.task.interventionId]);


    const FieldTemplate = (props) => {
        return (
            <div className="d-flex"><small className='meta-field-customer'>{props.label} </small><small className="customer-field">{props.value}</small></div>
        );
    }

    const INTERVENTION_FIELDS = [
        {
            label: "Creation date",
            value: new Date(props.task.creationDate).toLocaleString()
        },
        {
            label: "Source",
            value: props.task.source?.description
        },
        {
            label: "Source Type",
            value: props.task.source?.sourceType?.description
        },
        {
            label: "Task priority",
            value: props.task.source?.priority
        },
        {
            label: "Task SLA",
            value: props.task.source?.sla
        },
        {
            label: "Intervention Id",
            value: props.task.interventionId
        }
    ]


    return (
        <>
            <div className="text-center my-3">
                <span className='px-3'>Elapsed time of the intervention session</span>
            </div>
            <div className="mui-chip p-3 d-flex justify-content-between session-clock-content">
                <span className="ml-3">
                    {currentClock.days}
                </span>
                <span>
                    {currentClock.hours}
                </span>
                <span>
                    {currentClock.minutes}
                </span>
                <span className="mr-3">
                    {currentClock.seconds}
                </span>
            </div>

            <InterventionStatusCard intervention={props.task} />

            <div className="my-3">
                {INTERVENTION_FIELDS.map(item => <FieldTemplate {...item} />)}
            </div>

        </>
    );
}

/**
 * Intervention recap status component
 * @param {Object} props {intervention} 
 * @returns React.Component
 */
export const InterventionStatusCard = (props) => {
    const { intervention } = props;
    return (
        <div className='my-3 d-flex' style={{ width: "100%", borderRadius: "5px", border: "1px solid gray" }}>
            <span className={`py-4 text-center bg-${utils.guessStatusIcon(intervention.status.statusId).color}`} style={{ width: "3.5rem", borderRadius: "5px 0 0 5px" }}>
                <i className={`${utils.guessStatusIcon(intervention.status.statusId).icon} text-white`} style={{ fontSize: "22px" }} />
            </span>
            <div className='m-2 w-100'>
                <div className='d-flex justify-content-between'>
                    <strong>{utils.capitalizeStr(intervention?.status?.statusId)}</strong>
                    <small>{new Date(intervention.statusDate).toLocaleString()}</small>
                </div>
                <div className='d-flex justify-content-between'>
                    <div style={{ display: "grid" }}>
                        <small><label className='mr-3 mb-0'>Spent</label>{utils.msToDHMSBis(new Date(intervention.statusDate).getTime() - new Date(intervention.creationDate).getTime())}</small>
                        <small><label className='mr-3 mb-0'>Agent</label> {intervention.username}</small>
                    </div>
                    <i className={utils.guessSourceIcon(intervention.source.sourceId)} title={intervention.source.sourceId} style={{ color: "#0d88ef" }} />
                </div>
            </div>
        </div>
    );
}